import { AxiosResponse } from 'axios';

import { axios } from '../base/bootstrap';

import AbstractApi from './AbstractApi';

class PageSettingsApi extends AbstractApi {
    protected apiPrefix = '/page-settings/';
    protected endpoint: string = '';

    protected getAxios = () => axios;

    isImgVisible(): Promise<AxiosResponse> {
        return this.get('img-visible');
    }
}

export default new PageSettingsApi();
